
import React, { Fragment, useState } from "react";
import { DownloadOutlined, EyeOutlined } from "@ant-design/icons";

import { Accordion, Button, Card, Col, Container, Row } from "react-bootstrap";
import { Fade } from "react-reveal";


const financialReportsData = [{
    year: 2024, children: [
        {
            title: "Director Report - Dec 2024",
            link: `${process.env.REACT_APP_ASSETS_URL}Assets/pdf/Director Report - Dec 2024.pdf`
        },
        {
            title: "FS Half Year Ended June 2024",
            link: `${process.env.REACT_APP_ASSETS_URL}Assets/pdf/FS Half Year Ended June 2024.pdf`
        },
        {
            title: "FS Year Ended Dec 2024",
            link: `${process.env.REACT_APP_ASSETS_URL}Assets/pdf/FS Year Ended Dec 2024.pdf`
        },
    ],

}]

const backgroundImageUrl = `${process.env.REACT_APP_ASSETS_URL}/Assets/img/FINANCIAL-REPORTS.jpg`;

const bannerStyle = {
    backgroundImage: `url(${backgroundImageUrl})`,
};

const AccordionRow = ({ year, children }) => <Row>
    <Fade up delay={500}>

        <Col sm={12} className="financialReports" style={{ padding: '10px 50px', textAlign: "center" }}>
            <Accordion
                style={{
                    width: '100%',
                    maxWidth: '100%',
                    margin: '0 auto'
                }}
            >
                <Accordion.Item>
                    <Accordion.Header className="custom-accordion-header">
                        <h5 className="heading">{year}</h5>
                    </Accordion.Header>
                    {children}
                </Accordion.Item>
            </Accordion>
        </Col>
    </Fade>
</Row>

const AccordionBody = ({ data }) => <Accordion.Body className="custom-accordion-body">
    <Card className="m-3">
        <Card.Body className="d-flex align-items-center justify-content-between m-0">
            <span>
                {data.title}
            </span>
            <div>
                <a
                    href={data.link}
                    target="_blank"
                    download
                    title="Download"
                >
                    <DownloadOutlined />

                </a>
            </div>
        </Card.Body>
    </Card>
</Accordion.Body>

const FinancialReportsComponent = () => {


    return (
        <Fragment>
            <div className="col-sm-12 heads govbanner scroll-section" style={bannerStyle}>
                <Fade up delay={500}>
                    <h2 className="oswald">Financial Reports</h2>
                </Fade>
            </div>
            <Container style={{ minHeight: 300 }}>
                {
                    financialReportsData.map((report, index) => (

                        <AccordionRow key={index} year={report.year}>
                            {report.children.map((data, i) => (
                                <AccordionBody key={i} data={data} />
                            ))}
                        </AccordionRow>
                    ))
                }
            </Container>

            <div>

            </div>
        </Fragment>
    );
};

export default FinancialReportsComponent;
